import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

export const getList = params => {
  return axios.request({
    url: "/tool/hk/record",
    method: "get",
    params
  });
};

export const updateFile = data => {
  return axios.request({
    url: "/tool/hk/upload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

export const inboundHK = data => {
  return axios.request({
    url: "/tool/hk/awl",
    method: "post",
    data
  });
};

export const joinHK = data => {
  return axios.request({
    url: "/tool/hk/shk",
    method: "post",
    data
  });
};
